<template>
    <div class="form-component">
        <v-container fluid class="pa-0">
            <v-layout row wrap>
                <v-flex sm12 md12 id="landing">
                    <img src="./../assets/supplierSignup.png">
                </v-flex>
                <v-flex sm12 md12>
                    <v-form ref="form" class="px-5" v-model="valid">
                        <v-container fluid class="px-5 pt-1">
                            <v-layout align-center justify-center row wrap>
                                <v-flex class="px-4" xs6 md4>
                                </v-flex>
                                <v-flex class="px-4" xs6 md4>
                                    <v-layout justify-end row wrap>
                                        <v-flex class="btn-language" xs12 sm4 md6 lg4 xl3>
                                            <v-btn flat color="secondary" @click="changeLanguage()">
                                                <v-icon size="25px" dark>language</v-icon>
                                                <span class="appended-element button-content">
                                                    {{ this.$t('message.toggleLanguageText') }}
                                                </span>
                                            </v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center justify-center row wrap>
                                <v-flex class="px-4" xs12 md4>
                                    <v-text-field class="lance"
                                        v-bind:label="$t('message.formBusinessName')"
                                        v-model="form.businessName"
                                        :rules="[
                                            v => !!v || this.$t('message.formRequiredField'),
                                        ]">
                                    </v-text-field>
                                </v-flex>
                                <v-flex class="px-4" xs12 md4>
                                    <v-text-field class="lance"
                                        v-bind:label="$t('message.formContactEmail')"
                                        v-model="form.contactEmail"
                                        :rules="[
                                            v => !!v || this.$t('message.formRequiredField'),
                                            v => /.+@.+/.test(v) || this.$t('message.formInvalidInput'),
                                        ]">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center justify-center row wrap>
                                <v-flex class="px-4" xs12 md4>
                                    <v-text-field class="lance" 
                                        ref="rfc"
                                        v-bind:label="$t('message.formTaxID')"
                                        v-model="form.rfc"
                                        :rules="[
                                            v => !!v || this.$t('message.formRequiredField'),
                                        ]">
                                    </v-text-field>
                                </v-flex>
                                <v-flex class="px-4" xs12 md4>
                                    <v-text-field class="lance"
                                        v-bind:label="$t('message.formContactName')"
                                        v-model="form.contactName">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center justify-center row wrap>
                                <v-flex class="px-4" xs12 md4>
                                    <v-text-field
                                        class="lance"
                                        :label="$t('message.formSupplierCode')"
                                        v-model="form.code"
                                        :rules="[
                                            v => !!v || this.$t('message.formRequiredField')
                                        ]"
                                        >
                                    </v-text-field>
                                </v-flex>
                                <v-flex class="px-4" xs12 md4>
                                    <v-text-field class="lance"
                                        v-bind:label="$t('message.formContactPhone')"
                                        prefix="+"
                                        v-model="form.contactPhone"
                                        :rules="[
                                            v => (v === undefined || v===null || /(^$)|(^(\s*\d\s*){11,13}$)/.test(v)) || this.$t('message.formRequiredPhoneFormat')
                                        ]"
                                        @input="filterPhone">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout align-center justify-center row wrap>
                                <v-flex sm12 md2>
                                    <v-btn solo color="secondary" @click="goTo('/login')">
                                        <span class="button-content">
                                            {{ this.$t('message.backButtonText') }}
                                        </span>
                                    </v-btn>
                                </v-flex>
                                <v-flex sm12 md2>
                                    <v-btn solo color="primary" @click="save()" :disabled="!valid || sending">
                                        <span class="button-content">
                                            {{ this.$t('message.saveButtonText') }}
                                        </span>
                                    </v-btn>
                                </v-flex>
                            </v-layout>
                            <div class="subtext-container">
                                <div class="subtext">
                                    {{ this.$t('message.signupHelpText') }}
                                </div>
                            </div>
                        </v-container>
                    </v-form>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
import { events } from '../main';
import { i18n } from '../utils/locales/default';

export default {
    name: 'signup',
    data () {
        return {
            form: {
            },
            valid: false,
            sending: false,
        }
    },
    methods: {
        filterPhone() {
            this.$nextTick(() => {
                this.form.contactPhone = this.form.contactPhone.replace(/[^0-9 \,]/, '');
            });
        },
        goTo(url) {
            this.$router.push(url);
        },
        changeLanguage() {
            if (i18n.locale == "en") {
                i18n.locale = "es";
            } else {
                i18n.locale = "en";
            }

            for (let input of this.$refs.form.inputs) {
                if (input.hasMessages) {
                    input.validate(true);
                } else if (input.hasError) {
                    input.validate(false);
                }
            }
        },
        dataInit() {
            var self = this;
            this.$http.get('Suppliers/form')
            .then(response => {
                var newform = response.body.supplier;
                this.form = newform;
            });
        },
        save() {
            if (this.$refs.form.validate()) {
                this.sending = true;                    
                this.$http.post('Suppliers/', this.form)
                    .then(response => {
                        this.snackbar(this.$t('message.signupSuccessful'));
                        this.$router.push('/login');   
                    }, error => {
                        this.sending = false;                                
                        let message = this.$t('message.signupFail');
                        if (error.body.msg_id) {
                            message = this.$t(`message.${error.body.msg_id}`);
                        }
                        this.snackbar(message);
                        console.error(error);
                    });
            }
        },
        snackbar(message){
            events.$emit('snackbar', message);
        }
    },
    mounted() {
        const allowDirectLogin = process.env.VUE_APP_ALLOW_DIRECT_LOGIN === 'true';
        if (process.env.NODE_ENV != 'development' && !allowDirectLogin) {
            location.href = process.env.VUE_APP_URLEXTERNAL;
        }
        this.dataInit();
    },
    directives: {
        focus: {
            inserted: function (el) {
            el.focus()
            }
        }
    }
}
</script>

<style scoped>
    #form-component {
        background-color: #f2f2f2;
        color: #474747;
    }

    #signup-elements {
        margin-top: 45px;
    }

    .subtext {
        font-size: 14px;
        line-height: 18px;
    }

    .subtext-container {
        margin-top: 28px;
        text-align: center;
    }


    .appended-element {
        padding-left: 8px !important;
        padding-right: 2px !important;
    }

    .button-content {
        white-space: normal;
    }

    .btn-language {
        text-align: right;
    }

    .btn-language .v-btn {
        margin-right: 0;
        padding-left: 5px;
        padding-right: 5px;
        font-size: 16px;
        text-align: right;
        text-transform: none;
        border-radius: 0px !important;
    }

    #landing img {
        width: 100%;
    }

    @media screen and (max-width: 959px){
        #form {
            padding-left: 30px;
            padding-right: 30px;
        }

        #landing img {
            margin-bottom: 20px;
        }
    }
</style>